export default __webpack_public_path__ + "assets/static/data/blog-data.affdb16e38f43b4b1f9e2916a988a447.json";